import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    cloudy: 0,
    dashboardData: {},
    icon: '',
  },
  mutations: {
    changeCloudy(state, x){
      state.cloudy = x;
    },

    changeIcon(state, ico){
      state.icon = ico;
    },

    updateDashboardData(state, data){
      state.dashboardData = data;
    }
  },
  actions: {

  },
});
